import React from "react";
import { Globe2, Handshake, Rocket } from "lucide-react";

const AboutQuote = () => {
  return (
    <section className="bg-green-900 text-white py-20 px-6 md:px-12">
      <div className="max-w-5xl mx-auto text-center">
        {/* Main Quote */}
        <p className="text-xl md:text-2xl leading-relaxed font-light">
          “Daily Go is born from a passion to simplify everyday shopping. 
          We’re driven by the desire to make quality and savings accessible 
          to all, empowering small retailers and everyday shoppers alike.”
        </p>

        {/* Author Info */}
        <div className="mt-8">
          <p className="text-sm md:text-base text-gray-300">By Owner / Architect</p>
          <p className="text-lg md:text-xl font-semibold text-orange-400">
            Kiran G.S
          </p>
        </div>

        {/* Vision / Values / Mission */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Vision */}
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-lg p-6 text-left md:text-center hover:scale-105 transition-transform duration-300">
            <Globe2 className="w-10 h-10 mx-auto text-orange-400" />
            <h3 className="text-xl font-semibold text-orange-400 mt-4">Our Vision</h3>
            <p className="text-gray-200 mt-3 text-sm leading-relaxed">
              To become the most trusted wholesale partner for local businesses,
              connecting them with reliable and affordable supplies.
            </p>
            <p className="text-gray-200 mt-3 text-sm leading-relaxed">
              We aim to transform wholesale shopping into a seamless, 
              technology-driven experience for every retailer.
            </p>
          </div>

          {/* Values */}
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-lg p-6 text-left md:text-center hover:scale-105 transition-transform duration-300">
            <Handshake className="w-10 h-10 mx-auto text-orange-400" />
            <h3 className="text-xl font-semibold text-orange-400 mt-4">Our Values</h3>
            <p className="text-gray-200 mt-3 text-sm leading-relaxed">
              Integrity, transparency, and innovation are at the heart of Daily Go.
              We are committed to building long-term relationships by delivering
              consistent quality and customer-focused solutions.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-lg p-6 text-left md:text-center hover:scale-105 transition-transform duration-300">
            <Rocket className="w-10 h-10 mx-auto text-orange-400" />
            <h3 className="text-xl font-semibold text-orange-400 mt-4">Our Mission</h3>
            <p className="text-gray-200 mt-3 text-sm leading-relaxed">
              To empower retailers and shoppers by providing smarter access to
              wholesale products, reliable delivery services, and sustainable margins.  
            </p>
            <p className="text-gray-200 mt-3 text-sm leading-relaxed">
              Our mission is to drive growth for small businesses while ensuring 
              affordability and convenience for everyday consumers.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutQuote;
